import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import "./ServicePages.css";

const UsFdaRegistration = () => {
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }



  return (
    <div className="service-page">

      {/* HERO */}
      <div className="hero">

        <h1>US FDA Registration Services</h1>

        <p className="subtitle">
          Get US FDA Approval for Your Export Business
        </p>

        <p className="desc">
          Sell Your Products in the United States with Full Compliance
        </p>

        <p className="desc">
          We assist manufacturers, exporters, and food businesses in obtaining US FDA registration and compliance approvals, helping you enter the American market smoothly and legally.
        </p>

        <div className="badges">
          <span>✔ Fast Registration Support</span>
          <span>✔ Expert Compliance Guidance</span>
          <span>✔ End-to-End Assistance</span>
          <span>✔ Hassle-Free Process</span>
        </div>

        <div className="hero-action">
                    <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
                </div>



      </div>

      {/* WHAT IS FDA */}
      <div className="section">
        <h2>What is US FDA Registration?</h2>
        <p>
          US FDA Registration is mandatory for businesses involved in manufacturing, processing, packing, or exporting food, beverages, drugs, cosmetics, or medical devices to the United States.
        </p>
        <p>
          It is issued and regulated by the U.S. Food and Drug Administration.
        </p>
      </div>

      {/* IMPORTANCE */}
      <div className="section">
        <h2>Why US FDA Registration is Important</h2>
        <ul>
          <li>Mandatory for exporting regulated products to the USA</li>
          <li>Ensures product safety and compliance</li>
          <li>Builds international trust and credibility</li>
          <li>Required for customs clearance in the US</li>
          <li>Opens access to one of the world’s largest markets</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="section">
        <h2>Benefits of US FDA Registration</h2>
        <ul>
          <li>Legal entry into the US market</li>
          <li>Increased global business opportunities</li>
          <li>Higher brand trust and recognition</li>
          <li>Compliance with international standards</li>
          <li>Smooth export approval process</li>
        </ul>
      </div>

      {/* WHO NEEDS */}
      <div className="section">
        <h2>Who Needs US FDA Registration?</h2>
        <ul>
          <li>Food manufacturers & exporters</li>
          <li>Beverage companies</li>
          <li>Pharmaceutical companies</li>
          <li>Cosmetic manufacturers</li>
          <li>Medical device exporters</li>
          <li>Packaging units supplying regulated goods</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="section">
        <h2>Documents Required</h2>
        <ul>
          <li>Business Registration Certificate</li>
          <li>PAN Card / Company Details</li>
          <li>Product List</li>
          <li>Manufacturing Address Details</li>
          <li>Contact Information (US Agent if applicable)</li>
          <li>Labeling & Product Information</li>
        </ul>
      </div>

      {/* PROCESS */}
      <div className="section">
        <h2>US FDA Registration Process</h2>
        <ol>
          <li>Consultation – Identify product category</li>
          <li>Document Collection – Gather required details</li>
          <li>FDA Application Filing – Submit registration details</li>
          <li>Verification – FDA review process</li>
          <li>Registration Approval – Receive FDA registration number</li>
        </ol>
      </div>

      {/* WHY CHOOSE US */}
      <div className="section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>Expert FDA Compliance Team</li>
          <li>Fast & Reliable Process</li>
          <li>Complete Documentation Support</li>
          <li>Affordable Service Packages</li>
          <li>End-to-End Export Assistance</li>
        </ul>
      </div>

      {/* FAQ */}
      <div className="section">
        <h2>FAQs</h2>
        <p><b>Is US FDA registration mandatory?</b> Yes, for exporting regulated products like food, drugs, cosmetics, and medical devices to the USA.</p>
        <p><b>How long does FDA registration take?</b> Typically 5–10 working days depending on documentation.</p>
        <p><b>Is FDA approval same as product approval?</b> No, registration is for facility compliance; product approval may require additional steps.</p>
        <p><b>Do I need a US agent?</b> Yes, in most cases foreign companies need a US-based agent for FDA communication.</p>
      </div>

      {/* CTA */}
      <div className="cta" ref={contactRef}>
        <h2>Export to the USA with Confidence</h2>
        <p>Get your FDA registration done by experts.</p>
           <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
      </div>

    </div>
  );
};

export default UsFdaRegistration;